export default "__VITE_ASSET__HIQWHCIx__"